module.exports = __webpack_public_path__ + "static/media/Cart.5cc35a00.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Cart.webp
// module id = 203
// module chunks = 15